import { render, staticRenderFns } from "./Equipo_especializado.vue?vue&type=template&id=05da1476&"
import script from "./Equipo_especializado.vue?vue&type=script&lang=js&"
export * from "./Equipo_especializado.vue?vue&type=script&lang=js&"
import style0 from "./Equipo_especializado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports